import React, {useState} from "react";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import {Card, CardBody, CardImg, CardTitle} from "react-bootstrap";
import {img} from "../../utils/ImageUtil.ts";

interface FormatGoodsSwiperProps{
    goodsList: FormatGoodsDto[];
    showName?: boolean;
    appendClass?: string;
    handleSelected?: (dto: FormatGoodsDto) => void;
}

const FormatGoodsSwiper:React.FC<FormatGoodsSwiperProps> = (
    {
        goodsList = [],
        showName = false,
        appendClass = '',
        handleSelected = () => {}
    }
) => {
    const [selectedGoodsCode, setSelectedGoodsCode] = useState<string>("");
    const onClickGoods = (dto:FormatGoodsDto)=> {
        if(dto && dto.format_goods_code){
            setSelectedGoodsCode(dto.format_goods_code);
        }else {
            setSelectedGoodsCode("");
        }
        handleSelected(dto);
    }
    if(goodsList && goodsList.length != 0){
        return (
            <Swiper className={appendClass}
                    spaceBetween={10}
                    slidesPerView={1.5}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        768: {slidesPerView: 4.5}
                    }}
            >
                {goodsList.map( ((goodsDto, idx) => (
                    <SwiperSlide key={`format_goods_swiper_slide_${idx}`}
                                 className={`${goodsDto.format_goods_code === selectedGoodsCode ? 'selected-slide' : ''}`}
                    >
                        <Card className="format-goods-slide-card"
                              onClick={() => {onClickGoods(goodsDto)}}
                        >
                            <CardImg variant={"top"}
                                     src={img(goodsDto.goods_image_path)}
                            />
                            {showName &&
                                <CardBody>
                                    <CardTitle>{goodsDto.format_goods_name}</CardTitle>
                                </CardBody>
                            }
                        </Card>
                    </SwiperSlide>
                )))}
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </Swiper>
        );
    }
    return null;
};
export default FormatGoodsSwiper;